<template>
    <path fill-rule="evenodd" d="M8 20.21C8 22.3 6.206 24 4 24s-4-1.7-4-3.79c0-2.089 1.794-3.789 4-3.789s4 1.7 4 3.79zM.25 1.138l.648 12.27c.03.577.533 1.03 1.142 1.03h3.92c.61 0 1.112-.453 1.142-1.03l.648-12.27C7.782.518 7.262 0 6.608 0H1.392C.738 0 .218.518.25 1.137z"/>
</template>

<script>
export default {
    name: 'warningNoteIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 8 24');
    }
}
</script>